import React from 'react';
import '../template-file-css/document-file-template.css';


export const RNFI_LimitsToLiability = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RNFI_LimitsToLiability' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'><center><h3>CLIENT DISCLAIMER RELEASE OF LIABILITY NOTICE AGREEMENT</h3></center></p><br />
                <p className='w-750'>Ravens Nest Foundation, INC (Hereinafter referred to as "RNF INC") shall employ reasonable measures to ensure
                    the safety and welfare of their Clients. These reasonable precautions shall be determined to be those acts and or measures
                    that any reasonable person would employ or demonstrate under the same or similar circumstances. "RNF, INC" shall not be
                    held responsible or liable in any manner and is hereby released from any and all liability or acts that may be committed by
                    any "Client "or "Client's Consumer/Guardian" against another "Client "or "Client's Consumer/Guardian "or any other
                    person(s) during any meeting, function, activity and/or event "RNF" may host or sponsor on or off their premises.</p>
                <p className='w-750'>Pursuant hereto, "On premises "shall be defined as being conducted, sponsored and/or held in or on any property,
                    grounds and/or buildings owned or perpetually leased by "RNF, INC". "Off premises" shall be defined as any location,
                    building, park, mall, theatre, restaurant, arcade, theme park owned, leased and/or operated by any other organization,
                    corporation or individual other than "RNF, INC"." Perpetual Leases" for the purpose of this DISCLAIMER RELEASE OF
                    LIABILITY NOTICE/AGREEMENT, shall be defined as "Property Leases" and shall not be determined to include any type of
                    Interim Lease designed for a specific event or purpose.</p>
                <p className='w-750'>Specifically, whenever "RNF, INC" hosts and/or sponsors any meeting, function, activity or event whether that
                    meeting, function, activity or event is held on or off any premises or property leased or owned by" RNF, INC", they shall not
                    be assumed or determined to have assumed any liability and is hereby released from any and all liability for "Clients' or
                    Client's Consumer/Guardians'"acts or actions that may be interpreted to cause or have caused harm to any other "Client or
                    Client's Consumer/Guardian" or person during that persons presence at any meeting, function, activity and/or event hosted
                    and/or conducted by "RNF, INC", on or off their premises.</p>
                <p className='w-750'>Any person and/or entity acting on behalf of "RNF, INC" must possess express written consent/permission to act on
                    their behalf in any capacity. Such written consent or permission shall not be assumed to create liability for"RNF,INC" for the
                    acts or actions of such individuals or entities.</p>
                <p className='w-750'>"RNF, INC" is also released from any liability with regard to any acts of third parties, whether vendors, contractors or
                    invitees that may be interpreted as harmful to any "Clients or Consumer/Guardians" either on/or off premises.</p>
                <p className='w-750'> <center>This, DISCLAIMER RELEASE OF LIABILITY NOTICE AGREEMENT</center></p>
                <p className='w-750'>shall be deemed executed as of the date of signing, represented by the signature
                    below.</p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className="small w-375"> Signature of Patient or Legal Guardian</td>
                        <td className='small w-375'>Patient Name: </td>
                    </tr>
                </table>
            </div>
        </form>

    )
}











